import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Modal,
  Form,
  Pagination,
} from "react-bootstrap";

import axios from "axios";

import { getItem } from "../../../services/routes.backend.services";
import constants from "../../../services/constants";

import { FaEdit, FaTrash } from "react-icons/fa";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { useForm, useFieldArray } from "react-hook-form";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useSelector } from "react-redux";

const DeliverableSection = () => {
  const [items, setItems] = useState([]);

  const [show, setShow] = useState(false);

  const [currentItem, setCurrentItem] = useState({
    title: "",
    link: "",
    fields: [],
    links: [],
    externalLink: "",
    heading: "",
    description: "",
    image: "",
  });

  const [editing, setEditing] = useState(false);

  const [index, setIndex] = useState(null);

  const [serviceHeading, setServiceHeading] =
    useState([]);

  const [selectedValue, setSelectedValue] =
    useState("");

  const [searchTerm, setSearchTerm] =
    useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const itemsPerPage = 5;

  const { token } = useSelector(
    (state) => state.auth
  );

  const userRole = useSelector(
    (state) => state.auth.user?.role
  );

  const {
    register,
    handleSubmit,
    setValue,
    control,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      link: "",
      externalLink: "",
      heading: "",
      description: "",
      image: "",
      fields: [],
      links: [],
    },
  });

  // ============================================
  // FIELD ARRAY
  // ============================================

  const {
    fields,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "fields",
  });

  // ============================================
  // LINK ARRAY
  // ============================================

  const {
    fields: linkFields,
    append: appendLink,
    remove: removeLink,
  } = useFieldArray({
    control,
    name: "links",
  });

  const [previewIcons, setPreviewIcons] =
    useState({});

  // ============================================
  // FETCH DATA
  // ============================================

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await getItem(
        "deliverableservices"
      );

      setItems(response.data.delivirable);
    } catch (error) {
      console.error(error);
    }

    try {
      const response = await getItem(
        "homeservicesimage"
      );

      setServiceHeading(
        response.data.homeserviceimage
      );
    } catch (error) {
      console.error(error);
    }
  };

  // ============================================
  // HANDLE CLOSE
  // ============================================

  const handleClose = () => {
    setShow(false);

    setEditing(false);

    reset({
      title: "",
      link: "",
      externalLink: "",
      heading: "",
      description: "",
      image: "",
      fields: [],
      links: [],
    });

    setSelectedValue("");
  };

  const handleShow = () => setShow(true);

  // ============================================
  // SERVICE CHANGE
  // ============================================

  const handleServiceChange = (e) => {
    const selectedService = e.target.value;

    setSelectedValue(selectedService);

    const selectedServiceObj =
      serviceHeading.find(
        (service) =>
          service.text === selectedService
      );

    if (selectedServiceObj) {
      setValue("link", selectedServiceObj.link);
    }
  };

  // ============================================
  // SUBMIT
  // ============================================

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("title", selectedValue);

      formData.append("link", data.link);

      formData.append(
        "externalLink",
        data.externalLink
      );

      formData.append("heading", data.heading);

      formData.append(
        "description",
        data.description
      );

      // IMAGE
      if (data.image && data.image[0]) {
        formData.append(
          "image",
          data.image[0]
        );
      }

      // ============================================
      // FIELDS
      // ============================================

      data.fields.forEach((field, index) => {
        formData.append(
          `fields[${index}][title]`,
          field.title
        );

        formData.append(
          `fields[${index}][order]`,
          field.order
        );

        formData.append(
          `fields[${index}][description]`,
          field.description
        );

        if (
          field.icon &&
          field.icon[0]
        ) {
          formData.append(
            `fields[${index}][icon]`,
            field.icon[0]
          );
        }
      });

      // ============================================
      // LINKS
      // ============================================

      data.links.forEach((link, index) => {
        formData.append(
          `links[${index}][name]`,
          link.name
        );

        formData.append(
          `links[${index}][link]`,
          link.link
        );

        formData.append(
          `links[${index}][description]`,
          link.description
        );

        if (
          link.attachment &&
          link.attachment[0]
        ) {
          formData.append(
            `links[${index}][attachment]`,
            link.attachment[0]
          );
        }
      });

      const config = {
        headers: {
          "Content-Type":
            "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };

      if (editing) {
        await axios.put(
          `${constants.API_BASE_URL}deliverableservices/${currentItem._id}`,
          formData,
          config
        );

        toast.success("Updated Successfully");
      } else {
        await axios.post(
          `${constants.API_BASE_URL}deliverableservices`,
          formData,
          config
        );

        toast.success("Added Successfully");
      }

      handleClose();

      fetchData();
    } catch (error) {
      console.error(error);

      toast.error("Something went wrong");
    }
  };

  // ============================================
  // EDIT
  // ============================================

  const handleEdit = (item) => {
    setCurrentItem(item);

    setIndex(
      items.findIndex(
        (i) => i._id === item._id
      )
    );

    setEditing(true);

    setSelectedValue(item.title);

    setValue("link", item.link);

    setValue(
      "externalLink",
      item.externalLink
    );

    setValue("heading", item.heading);

    setValue(
      "description",
      item.description
    );

    setValue(
      "fields",
      item.fields || []
    );

    setValue(
      "links",
      item.links || []
    );

    handleShow();
  };

  // ============================================
  // DELETE
  // ============================================

  const handleDelete = async (item) => {
    try {
      await axios.delete(
        `${constants.API_BASE_URL}deliverableservices/${item._id}`
      );

      toast.success("Deleted Successfully");

      fetchData();
    } catch (error) {
      console.error(error);

      toast.error("Delete failed");
    }
  };

  // ============================================
  // REMOVE FIELD
  // ============================================

  const handleRemovefield = async (
    serviceID,
    fieldID,
    indx
  ) => {
    try {
      const response = await axios.delete(
        `${constants.API_BASE_URL}deliverableservices/deliverableservice/${serviceID}/field/${fieldID}`
      );

      toast.success(response.data.message);

      remove(indx);
    } catch (error) {
      console.error(error);
    }
  };

  // ============================================
  // REMOVE LINK
  // ============================================

  const handleRemoveLink = async (
    serviceID,
    linkID,
    indx
  ) => {
    try {
      const response = await axios.delete(
        `${constants.API_BASE_URL}deliverableservices/deliverableservice/${serviceID}/link/${linkID}`
      );

      toast.success(response.data.message);

      removeLink(indx);
    } catch (error) {
      console.error(error);
    }
  };

  // ============================================
  // SEARCH
  // ============================================

  const filteredItems = items?.filter((item) =>
    item?.title
      ?.toLowerCase()
      .includes(searchTerm?.toLowerCase())
  );

  const paginatedItems =
    filteredItems?.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );

const pageCount = Math.ceil(
  (filteredItems?.length ?? 0) / itemsPerPage
);

  return (
    <Container>
      <ToastContainer />

      <Row className="my-4">
        <Col md={6}>
          <Button onClick={handleShow}>
            Add Deliverable
          </Button>
        </Col>

        <Col md={6}>
          <Form.Control
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(e.target.value)
            }
          />
        </Col>
      </Row>

      {/* TABLE */}

      <Row>
        <Col>
          <Table bordered striped hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Title</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {paginatedItems?.map(
                (item, idx) => (
                  <tr key={item._id}>
                    <td>
                      {(currentPage - 1) *
                        itemsPerPage +
                        idx +
                        1}
                    </td>

                    <td>{item.title}</td>

                    <td>
                      <Button
                        variant="warning"
                        onClick={() =>
                          handleEdit(item)
                        }
                      >
                        <FaEdit />
                      </Button>{" "}

                      {userRole === "user" && (
                        <Button
                          variant="danger"
                          onClick={() =>
                            handleDelete(item)
                          }
                        >
                          <FaTrash />
                        </Button>
                      )}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </Table>

          <Pagination>
            {[...Array(pageCount)?.keys()].map(
              (pageNumber) => (
                <Pagination.Item
                  key={pageNumber}
                  active={
                    pageNumber + 1 ===
                    currentPage
                  }
                  onClick={() =>
                    setCurrentPage(
                      pageNumber + 1
                    )
                  }
                >
                  {pageNumber + 1}
                </Pagination.Item>
              )
            )}
          </Pagination>
        </Col>
      </Row>

      {/* MODAL */}

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editing
              ? "Edit Deliverable"
              : "Add Deliverable"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form
            onSubmit={handleSubmit(onSubmit)}
          >
            {/* TITLE */}

            <Form.Group className="mb-3">
              <Form.Label>
                Select Title
              </Form.Label>

              <Form.Select
                value={selectedValue}
                onChange={handleServiceChange}
                // disabled={editing}
              >
                <option value="">
                  Select
                </option>

                {serviceHeading.map(
                  (service) => (
                    <option
                      key={service._id}
                      value={service.text}
                    >
                      {service.text}
                    </option>
                  )
                )}
              </Form.Select>
            </Form.Group>

            {/* LINK */}

            <Form.Group className="mb-3">
              <Form.Label>Link</Form.Label>

              <Form.Control
                type="text"
                {...register("link")}
                //disabled={editing}
              />
            </Form.Group>

            {/* EXTERNAL LINK */}

            <Form.Group className="mb-3">
              <Form.Label>
                External Link
              </Form.Label>

              <Form.Control
                type="text"
                {...register(
                  "externalLink"
                )}
              />
            </Form.Group>

            {/* HEADING */}

            <Form.Group className="mb-3">
              <Form.Label>
                Heading
              </Form.Label>

              <Form.Control
                type="text"
                {...register("heading")}
              />
            </Form.Group>

            {/* DESCRIPTION */}

            <Form.Group className="mb-3">
              <Form.Label>
                Description
              </Form.Label>

              <ReactQuill
                value={watch("description")}
                onChange={(value) =>
                  setValue(
                    "description",
                    value
                  )
                }
              />
            </Form.Group>

            {/* IMAGE */}

            <Form.Group className="mb-3">
              <Form.Label>
                Main Image
              </Form.Label>

              <Form.Control
                type="file"
                {...register("image")}
              />
            </Form.Group>

            <hr />

            {/* FIELDS */}

            <h5>Fields</h5>

            {fields.map((field, idx) => (
              <div
                key={field.id}
                className="mb-4 border p-3"
              >
                <Form.Group className="mb-3">
                  <Form.Label>
                    Title
                  </Form.Label>

                  <Form.Control
                    type="text"
                    {...register(
                      `fields.${idx}.title`
                    )}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Description
                  </Form.Label>

                  <ReactQuill
                    value={watch(
                      `fields.${idx}.description`
                    )}
                    onChange={(value) =>
                      setValue(
                        `fields.${idx}.description`,
                        value
                      )
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Order
                  </Form.Label>

                  <Form.Control
                    type="number"
                    {...register(
                      `fields.${idx}.order`
                    )}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Icon
                  </Form.Label>

                  <Form.Control
                    type="file"
                    {...register(
                      `fields.${idx}.icon`
                    )}
                  />
                </Form.Group>

                <Button
                  variant="danger"
                  onClick={() =>
                    handleRemovefield(
                      currentItem._id,
                      field._id,
                      idx
                    )
                  }
                >
                  Remove Field
                </Button>
              </div>
            ))}

            <Button
              variant="primary"
              className="mb-3"
              onClick={() =>
                append({
                  title: "",
                  order: "",
                  description: "",
                  icon: "",
                })
              }
            >
              Add Field
            </Button>

            <hr />

            {/* LINKS */}

            <h5>Links</h5>

            {linkFields.map(
              (field, idx) => (
                <div
                  key={field.id}
                  className="mb-4 border p-3"
                >
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Name
                    </Form.Label>

                    <Form.Control
                      type="text"
                      {...register(
                        `links.${idx}.name`
                      )}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      Link
                    </Form.Label>

                    <Form.Control
                      type="text"
                      {...register(
                        `links.${idx}.link`
                      )}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      Description
                    </Form.Label>

                    <ReactQuill
                      value={watch(
                        `links.${idx}.description`
                      )}
                      onChange={(value) =>
                        setValue(
                          `links.${idx}.description`,
                          value
                        )
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>
                      Attachment
                    </Form.Label>

                    <Form.Control
                      type="file"
                      {...register(
                        `links.${idx}.attachment`
                      )}
                    />
                  </Form.Group>

                  <Button
                    variant="danger"
                    onClick={() =>
                      handleRemoveLink(
                        currentItem._id,
                        field._id,
                        idx
                      )
                    }
                  >
                    Remove Link
                  </Button>
                </div>
              )
            )}

            <Button
              variant="primary"
              className="mb-3"
              onClick={() =>
                appendLink({
                  name: "",
                  link: "",
                  description: "",
                  attachment: "",
                })
              }
            >
              Add Link
            </Button>

            <hr />

            <Button
              type="submit"
              variant="success"
            >
              {editing
                ? "Update"
                : "Save"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default DeliverableSection;